import React from 'react';
import { useTranslation } from 'react-i18next';
import { CartUploadAnimation } from '@ff-os/shared-react/components/loaders/upload-arrows/CartUploadAnimation';
import { CloudUploadAnimation } from '@ff-os/shared-react/components/loaders/upload-arrows/CloudUploadAnimation';
import { WindowBody } from '@ff-os/shared-react/components/window/partials/WindowBody';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { Window } from '@ff-os/shared-react/components/window/Window';
import { noop } from 'lodash';
import styles from './AddingToCartWindow.module.scss';

export const AddingToCartWindow = ({ amountOfUploadsRemaining, close, isAddingToCart }: Props) => {

    const { t } = useTranslation();

    if (amountOfUploadsRemaining > 0) {
        return (
            <Window close={close} size='sm' mobileOrigin='center'>
                <div className={styles.window}>
                    <WindowHeader className={styles.header} onClose={close} />
                    <WindowBody>
                        <div className={styles.content}>
                            <CloudUploadAnimation className={styles.icon} />
                            <h3 className={styles.title}>
                                {t('upload_progress.amount_of_uploads_remaining', {
                                    count: amountOfUploadsRemaining
                                })}
                            </h3>
                            <p className={styles.subtitle}>{t('photo_prints.uploading_subtitle')}</p>
                        </div>
                    </WindowBody>
                </div>
            </Window>
        );
    } else if (isAddingToCart) {
        return (
            <Window close={noop} size='sm' mobileOrigin='center'>
                <WindowBody>
                    <div className={styles.content}>
                        <CartUploadAnimation className={styles.icon} />
                        <h3 className={styles.title}>
                            {t('photo_prints.adding_to_cart')}
                        </h3>
                        <p className={styles.subtitle}>{t('photo_prints.adding_to_cart_subtitle')}</p>
                    </div>
                </WindowBody>
            </Window>
        );
    } else {
        return null;
    }
};

type Props = {
    close: () => void;
    isAddingToCart: boolean;
    amountOfUploadsRemaining: number;
};